module.exports = "../images/the-patricia-ear-falls-waterfront@2x.jpg?v=ee9ea46";